import PropTypes from 'prop-types';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Dropzone from 'react-dropzone';
import FaImage from 'react-icons/lib/fa/image';
import FaTimesCircle from 'react-icons/lib/fa/times-circle';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { getThumbnailUrl } from '~services/utils'; // eslint-disable-line

import messages from './messages/PaidFeatures_messages';
import dropzoneStyles from './dropzoneStyles';

import Button from '../../components/Button';
import { Input, InputGroup, Label, Textarea } from '../../components/Form';

const propTypes = {
  editMode: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleImageUpload: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  removeSlide: PropTypes.func.isRequired,
  slide: PropTypes.object.isRequired,
};

const PortfolioSlide = ({
  editMode,
  handleChange,
  handleImageUpload,
  index,
  removeSlide,
  slide,
}) => (
  <Draggable
    draggableId={`${slide.id}`} // Needs to be a string.
    index={index}
    key={slide.id}
    isDragDisabled={!editMode}
  >
    {provided => (
      <Slide
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
        order={slide.order_no}
      >
        <Dropzone
          accept={'image/jpg, image/jpeg, image/png, image/gif'}
          disabled={!editMode}
          multiple={false}
          onDrop={handleImageUpload}
          style={dropzoneStyles}
          >
            <SlideImage>
              {!slide.image_id && (
                <React.Fragment>
                  <AddImageIcon />
                  <FormattedMessage
                    {...messages.addImage}
                    info="Add image"
                  />
                </React.Fragment>
              )}
              {!!slide.image_id && (
                <Image
                  src={getThumbnailUrl(slide.image_id, false)}
                />
              )}
            </SlideImage>
          </Dropzone>

          <SlideInfo>
            <InputGroup>
              <Label>
                <FormattedMessage
                  {...messages.slideTitleLabel}
                  info="Page title label"
                />
              </Label>
              <TitleInput
                disabled={!editMode}
                onChange={({ target: { value }}) =>
                handleChange({
                  field: 'title',
                  slideId: slide.id,
                  value,
                })
              }
              value={slide.title}
            />
          </InputGroup>
          <InputGroup>
            <Label>
              <FormattedMessage
                {...messages.textContentLabel}
                info="Page content label."
              /> ({ slide.description.length } / 550)
            </Label>
            <ContentTextarea
              disabled={!editMode}
              rows="4"
              onChange={({ target: { value }}) =>
              handleChange({
                field: 'description',
                slideId: slide.id,
                value
              })
            }
            value={slide.description}
          />
        </InputGroup>
        {editMode && (
          <RemoveButton
            className='remove-brochure-slide-button'
            color='red'
            onClick={() => removeSlide({'slideId': slide.id})}
            >
              <RemoveIcon />
              <FormattedMessage
                {...messages.removeSlide}
                info="Remove slide"
              />
            </RemoveButton>
          )}
        </SlideInfo>
      </Slide>
    )}
  </Draggable>
);

const AddImageIcon = styled(FaImage)`
  font-size: 20pt;
  margin-bottom: 6px;
`;

const ContentTextarea = styled(Textarea)`
  &[disabled] {
    background-color: #ffffff;
    border-color: #ffffff;

    &:hover {
      cursor: default;
    }
  }
`;

const Image = styled.img``;

const RemoveButton = styled(Button)`
  align-self: flex-start;
`;

const RemoveIcon = styled(FaTimesCircle)`
  margin-right: 6px;
`;

const Slide = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
  order: ${props => props.order};

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

const SlideInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: auto;
`;

const SlideImage = styled.div`
  align-items: center;
  box-sizing: border-box;
  color: ${props => props.theme['grey-normal']};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 12px;
  width: 100%;
`;

const TitleInput = styled(Input)`
  &[disabled] {
    background-color: #ffffff;
    border-color: #ffffff;

    &:hover {
      cursor: default;
    }
  }
`;

PortfolioSlide.propTypes = propTypes;
export default PortfolioSlide;
